if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      if (!this.cartNotification) {
        console.warn('⚠️ cart-notification element not found. Fallback mode active.');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const formData = new FormData(this.form);

      // ✅ Safe fallback if cart-notification or getSectionsToRender() is missing
      if (!document.querySelector(".ajax-cart-disabled")) {
        if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cartNotification.getSectionsToRender().map((section) => section.id)
          );
        } else {
          // Fallback default sections
          formData.append(
  'sections',
  ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-upsell', 'cart-drawer-gift']
);

        }
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${routes.cart_add_url}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-upsell,cart-drawer-gift&sections_url=${window.location.pathname}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // ✅ Render cart notification and open drawer (wait a bit for DOM update)
          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents({
  id: response.id,
  sections: response.sections
});

            // 🕒 Add slight delay to ensure HTML update completes before opening
            setTimeout(() => {
              if (typeof openCartDrawer === 'function') {
                openCartDrawer();
              } else {
                console.warn('⚠️ openCartDrawer() not found — cannot open drawer automatically.');
              }
            }, 200);
          } else {
            // fallback: open drawer immediately
            if (typeof openCartDrawer === 'function') openCartDrawer();
          }

          if (typeof initMotivatorProduct === 'function') {
            initMotivatorProduct();
          }
        })
        .catch((e) => {
          console.error('Add to Cart Error:', e);
          this.handleErrorMessage('Error adding to cart. Please try again.');
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage ||
        (this.errorMessageWrapper
          ? this.errorMessageWrapper.querySelector('.product-form__error-message')
          : null);

      if (!this.errorMessageWrapper || !this.errorMessage) return;

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* ================================
   VARIANT PRICE UPDATE HANDLER
   ================================ */

// Fallback formatter (in case Shopify.formatMoney isn't defined)
function formatMoney(amount, format) {
  const value = (amount / 100).toFixed(2);
  // Simple ₹ + number fallback; replace with your currency symbol if needed
  return `₹${value}`;
}

document.addEventListener('change', function(e) {
  // Detect variant selection (radio or dropdown)
  if (e.target.matches('.variant-radio, .select__select')) {
    const variantDataEl = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!variantDataEl) return;

    const variants = JSON.parse(variantDataEl.textContent);
    const selectedOptions = [];

    document.querySelectorAll('.variant-radio:checked, .select__select').forEach(el => {
      selectedOptions.push(el.value);
    });

    const matchedVariant = variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
    if (!matchedVariant) return;

    // Update "Select Value -:" price live
    const variantPriceEl = document.getElementById('variant-price');
    if (variantPriceEl) {
      const formatted = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
        ? Shopify.formatMoney(matchedVariant.price, "{{ shop.money_format }}")
        : formatMoney(matchedVariant.price);
      variantPriceEl.textContent = formatted;
    }

    // Optional: update hidden input so Add to Cart uses the right variant
    const hiddenInput = document.querySelector('form [name="id"]');
    if (hiddenInput) hiddenInput.value = matchedVariant.id;
  }
});
